export enum InstrumentsFormNameEnum {
  headerLogo = 'headerLogo',
  footerLogo = 'footerLogo',
}
